<template>
  <div class="comment__audit-compare-content comment__item-move-to-story comment__item-story">
    <div class="comment__item-story__left">
      <BaseSubHeading
        size="large"
        weight="500"
        color="monochrome-05"
        class="comment__item-story__number"
      >
        #{{ item.sequenceNumber }}
      </BaseSubHeading>
      <BaseSubHeading
        size="medium"
        weight="400"
        class="comment__item-story__title"
      >
        {{ item.title }}
      </BaseSubHeading>
    </div>
    <div class="comment__item-story__right">
      <StoryPoint :value="item.storyPoints" />
      <BaseSubHeading
        weight="600"
        size="medium"
        className="comment__item-story__hours"
        color="monochrome-05"
      >
        {{ item?.estimation ?? 0 }}<small> hr</small>
      </BaseSubHeading>
      <AvatarGroupTask
        :avatars="item.allUsersInItem"
        :user="true"
        :scaleByHover="false"
        type="avatarGroup"
        size="md"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"

import AvatarGroupTask from "@/components/Avatar/AvatarGroupTasks.vue"
import StoryPoint from "@/components/StoryPoint/index.vue"

import { Comment, Item } from "@/models"

const props = defineProps<{
  comment: Comment
}>()

const item = computed(() => Item.create(props.comment.itemAuditRecord?.after))
</script>
